import { OpenURLOptions, OpenURLResult } from "@electron-types/app-launcher";
import { createElectronPlugin } from "./electron-plugin.util";

export { OpenURLOptions, OpenURLResult };

interface AppLauncherPlugin {
    openUrl: (options: OpenURLOptions) => Promise<OpenURLResult>;
}

const AppLauncherElectron = createElectronPlugin<AppLauncherPlugin>('AppLauncher');

export default AppLauncherElectron;
